export const mapBackendToForm = (data) => {
  if (!data) return {};

  const dateFields = [
    "doctor_anaesthetist_signature_date_time",
    "doctor_signature_unable_consent_date_time",
    "witness_signature_date_time",
    "patient_signature_date_time",
    "interpreter_signature_date_time",
    "interpreter_signature_unable_consent_date_time",
    "patient_rep_signature_date_time",
    "patient_rep_witness_date_time",
    "patient_rep_doctor_signature_date_time",
    "patient_rep_interpreter_signature_date_time",
  ];

  const formattedDates = {};
  dateFields.forEach(field => {
    if (data[field]) {
      const date = new Date(data[field]);
      if (!isNaN(date.getTime())) {
        formattedDates[field] = date.toISOString().slice(0, 16);
      }
    }
  });

  return {
    ...data,
    ...formattedDates
  };
};

export const mapFormToBackend = (formData) => {
  return {
    ...formData,
    hospital_id: 1,
    // Add any necessary transformations here
  };
};

export const validateConsentForm = (formData) => {
  const errors = {};
  const requiredFields = [
    { key: 'operation_procedure', label: 'Operation / Procedure' },
    { key: 'patient_name', label: 'Patient Name' },
    { key: 'advised_of_major_risk', label: 'Advised of Major Risk' },
    { key: 'diagnosis', label: 'Diagnosis' },
  ];

  requiredFields.forEach(({ key, label }) => {
    if (!formData[key] || String(formData[key]).trim() === '') {
      errors[key] = `${label} is required`;
    }
  });

  return errors;
};
